import { cn, getSeverityLabel } from '../lib/utils'

interface SeverityBadgeProps {
  severity: number
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

function getSeverityClasses(severity: number): { bg: string; text: string } {
  if (severity >= 9) return { bg: 'bg-danger', text: 'text-white' }
  if (severity >= 7) return { bg: 'bg-warning', text: 'text-navy' }
  if (severity >= 5) return { bg: 'bg-yellow-400', text: 'text-navy' }
  if (severity >= 3) return { bg: 'bg-info', text: 'text-white' }
  return { bg: 'bg-gray-400', text: 'text-white' }
}

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
}

export function SeverityBadge({ severity, className, size = 'sm' }: SeverityBadgeProps) {
  const { bg, text } = getSeverityClasses(severity)
  const label = getSeverityLabel(severity)

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-semibold',
        bg,
        text,
        sizeClasses[size],
        className,
      )}
      role="img"
      aria-label={`Severity: ${label}`}
    >
      {label}
    </span>
  )
}
